import { requireEnv } from '../common/env';

export const PATIENT_PORTAL_SYSTEM_IDS = {
  MY_HEALTH: 'myhealth',
  AMPLAR: 'amplar',
} as const;

export type PatientPortalSystemOptions =
  (typeof PATIENT_PORTAL_SYSTEM_IDS)[keyof typeof PATIENT_PORTAL_SYSTEM_IDS];

export const PATIENT_PORTAL_SYSTEM_UUIDS = {
  myhealth: requireEnv(
    'VITE_MY_HEALTH_SYSTEM_ID',
    import.meta.env.VITE_MY_HEALTH_SYSTEM_ID,
  ),
  amplar: requireEnv(
    'VITE_AMPLAR_SYSTEM_ID',
    import.meta.env.VITE_AMPLAR_SYSTEM_ID,
  ),
} satisfies Record<PatientPortalSystemOptions, string>;

export const CONTAINER_BACKGROUND_COLOR = {
  myhealth: '$surfaceBackgroundSecondary',
  amplar: '$surfaceBackgroundPrimary',
} satisfies Record<PatientPortalSystemOptions, string>;
